import React from 'react';
import { Button, ButtonProps } from 'evergreen-ui';
import { styled } from 'linaria/react';
import { FC } from 'react';

export const AuthContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
`;

export const AuthForm = styled.form`
	width: 100%;
	margin: 16px;
	max-width: 480px;
	padding: 20px;
	background: white;
`;

export const AuthFormTitle = styled.h2`
	margin-bottom: 40px;
	font-weight: 300;
  font-size: 28px;
  line-height: 32px;
  text-align:center;
`;

export const AuthHint = styled.p`
	margin: 24px 0 0;
	font-size: 14px;
    text-align: center;
	
	a {
		color: var(--purple500);
	}
`;

export const ForgotLink = styled.a`
	display: block;
	text-align: right;
	margin-top: 10px;
	font-size: 14px;
	color: var(--purple500);
    padding-right: 15px;
`;

export const InputGroup = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 16px;
`;

export const AuthButton: FC<ButtonProps> = (props) => {
	return (
		<Button
			{...props}
			width={'80%'}
			height={40}
			style={{
                margin: 'auto',
				marginTop: 40,
				marginBottom: 40,
				textAlign: 'center',
				display: 'flex',
				justifyContent: 'center',
                 background: '#087587',
                color: '#fff',
                transition: 'all .4s',
                border: 'none',
                borderRadius: 30,
                padding: 12,
                fontSize: 16,
                outline: 'none',
                maxWidth: 300,
                fontFamily: 'Montserrat',
                fontWeight: 300,
                
			}}
		/>
	);
};
